import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StateService } from '../../state/state.service';

@Injectable()
export class AuthRedirectorService {

  constructor(private router: Router,
    private state: StateService) {
  }

  redirect() {
    const auth = this.state.snapshot.auth;

    if (!auth.isAuthenticated) {
      return this.router.navigate(['/', 'login']);
    }

    switch (auth.acl[0]) {
      case 'shp':
        return this.router.navigate(['shop']);
      case 'lab':
        return this.router.navigate(['lab']);
      case 'adm':
        return this.router.navigate(['admin']);
      case 'agn':
        return this.router.navigate(['agent']);
      case 'cli':
        return this.router.navigate(['client']);
      case 'mshp':
        return this.router.navigate(['mshp']);
      case 'cov':
        return this.router.navigate(['cover']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/auth/auth-redirector.service.ts